export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/e2d115f81737d89f246de6338bc29dde.png";